<template>
  <!-- 文件详情 弹框详情的内容 文件分享 -->
  <div id="fileSharing">
    文件详情 弹框详情的内容 文件分享
  </div>
</template>

<script>
export default {
  props: {
  },
  data() {
    return {
      
    }
  },
  components: {
    
  },
  computed: {
    
  },
  methods: {
    
  }
}
</script>

<style lang="less" scoped>
@import "~@/styles/variable.less";
@--line-color: #DCDEE2;
#listContentCom {
  .fileElements {
    height: 100%;
    background: #fff;
    overflow: auto;
    &::-webkit-scrollbar {
      display: none;  // 重点
    }
    .topLine {
      border-top: 1px solid @--line-color;
    }
    .elements {
      display: flex;
      min-height: 40px;
      border-bottom: 1px solid @--line-color;
      color: #515A6E;
      font-size: 12px;
      border-right: 1px solid @--line-color;
      &:nth-child(odd) {
        background-color: #F8F8F9;
      }
      .title {
        flex: 0 0 27%;
        text-align: center;
        border-left: 1px solid @--line-color;
        border-right: 1px solid @--line-color;
        line-height: 40px;
      }
      .content {
        flex: 1;
        text-align: center;
        // border-right: 1px solid @--line-color;
        margin: auto  0;
      }
    }
    .docContent {
      margin-bottom: 60px;
    }
  }
  .backStyle {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-around;
  }
  .loginBtn {
    height: 280px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-top: -210px;
    background: rgba(255, 255, 255, .9);
  }
  .listContent_active {
    margin-bottom: 20px;
    .doctitle {
      width: 315px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: #333333;
      // border: 1px solid red;
    }
    .msgContent {
      width: 315px;
      font-size: 12px;
      color: #A6A6A6;
      display: flex;
      justify-content: space-between;
      // border: 1px solid red;
      .time {
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .tag {
        min-width: 50px;
        margin-left: 4px;
        .tag {
          width: 100%;
          color: @--base-word-color;
        }
      }
    }
  }
}
</style>

<style lang="less">
hh1,
hh2,
hh3,
hh41,
hh42,
hh5,
hh6,
hh7,
hh81,
hh82,
sc,
p {
  margin: 0pt 2pt;
  font-weight: normal;
}

//文件名
hh1 {
  display: block;
  text-align: center;
  line-height: 170%;
  font-size: 14pt;
  font-weight: normal;
  font-weight: 700;
}

//文号
hh2 {
  text-align: center;
  line-height: 300%;
  font-size: 8pt;
  font-weight: normal;
  display: block;
  margin-top: 10pt;
}

//废止依据
hh3 {
  text-align: justify;
  line-height: 200%;
  font-size: 12pt;
  font-weight: normal;
  display: block;
}

hh4 {
  text-align: justify;
  line-height: 200%;
  font-size: 12pt;
  font-weight: normal;
  display: block;
}

hh41 {
  text-align: justify;
  line-height: 200%;
  font-size: 12pt;
  font-weight: normal;
  display: block;
}

hh42 {
  text-align: justify;
  line-height: 200%;
  font-size: 12pt;
  font-weight: normal;
  display: block;
}

//发文单位
hh5 {
  text-align: right;
  line-height: 200%;
  font-size: 11pt;
  font-weight: normal;
  display: block;
}

//发文时间
hh6 {
  text-align: right;
  line-height: 200%;
  font-size: 11pt;
  font-weight: normal;
  display: block;
}

//附件
hh7 {
  text-align: justify;
  line-height: 200%;
  font-size: 12pt;
  font-weight: normal;
  display: block;
}

// hh9 {
//   text-align: justify;
//   line-height: 300%;
//   font-size: 12pt;
//   font-weight: normal;
//   display: block;
// }

//相关链接
hh81 {
  text-align: justify;
  line-height: 200%;
  font-size: 12pt;
  font-weight: normal;
  display: block;
}

//版本汇总
hh82 {
  text-align: justify;
  line-height: 200%;
  font-size: 12pt;
  font-weight: normal;
  display: block;
}

sc {
  text-align: justify;
  line-height: 180%;
  font-size: 11pt;
  font-weight: normal;
  display: block;
  margin-top: 6pt;
}

basis {
  font-size: 12pt;
  font-weight: normal;
  line-height: 200%;
  color: #c00000;
}

potencedesc {
  text-align: justify;
  line-height: 200%;
  font-size: 12pt;
  font-weight: normal;
  display: block;
  color: #c00000;
}

tt {
  text-align: justify;
  line-height: 200%;
  font-size: 12pt;
  font-weight: normal;
}

sr {
  color: #c00000
}

.ls {
  //text-decoration: underline;
  color: blue;
  cursor: Pointer;
}

.ls_w:after {
  font-family: "iconfont" !important;
  font-size: 12pt;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\e62e";
  //background-image: url(../../../../static/images/img/download.png);
}

.ls_e {
  color: blue;
  cursor: Pointer;
}

.ls_z {
  color: blue;
  cursor: Pointer;
}

.ls_o {
  color: blue;
  cursor: Pointer;
}

.defaultFont {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  position: relative;
  min-height: 492px;
}

#hh9 {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-template-rows: 50px 50px 50px;
  grid-auto-flow: column;
}

hh9 {
  font-size: 16px;
  text-align: left;
  //border: 1px solid #e5e4e9;
}

hit {
  background-color: yellow;
}

.van-tab__text--ellipsis {
  -webkit-line-clamp: 2;
  text-align: center;
}
</style>
